<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="Auditoria">
        <Audit />
      </el-tab-pane>
      <el-tab-pane label="Auditoria de Estados">
        <AuditStates />
      </el-tab-pane>
      <el-tab-pane label="Auditoria de recargas">
        <AuditRecargas />
      </el-tab-pane>
      <el-tab-pane label="Auditoria de tarjeta">
        <AuditTarjeta />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Audit from "@/views/modules/audit-transactions/Audit.vue";
import AuditStates from "@/views/modules/audit-transactions/Audit-states/Audit-states.vue";
import AuditRecargas from "@/views/modules/audit-transactions/Audit-Recargas/Audit-Recargas.vue";
import AuditTarjeta from "@/views/modules/Audit-card/CardBalanceReport1.vue";

export default {
  name: "AuditMaster",
  components: {
    Audit,
    AuditStates,
    AuditRecargas,
    AuditTarjeta
  }
};
</script>

<style></style>
